import React, { useEffect } from 'react';
import './SuccessModal.css';

/**
 * Custom Success Modal Component
 * Displays after successful Calendly booking
 */
const SuccessModal = ({ isOpen, onClose, bookingData, appointmentType = "Appointment" }) => {
    // Close modal on Escape key
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener('keydown', handleEscape);
            // Prevent body scroll when modal is open
            document.body.style.overflow = 'hidden';
        }

        return () => {
            document.removeEventListener('keydown', handleEscape);
            document.body.style.overflow = 'unset';
        };
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <div className="success-modal-overlay" onClick={onClose}>
            <div
                className="success-modal-content"
                onClick={(e) => e.stopPropagation()}
                role="dialog"
                aria-modal="true"
                aria-labelledby="modal-title"
            >
                <button
                    className="success-modal-close"
                    onClick={onClose}
                    aria-label="Close modal"
                >
                    ×
                </button>

                <div className="success-modal-icon">
                    <svg
                        width="80"
                        height="80"
                        viewBox="0 0 80 80"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <defs>
                            <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                                <stop offset="0%" stopColor="#ec4899" />
                                <stop offset="100%" stopColor="#a855f7" />
                            </linearGradient>
                        </defs>
                        <circle cx="40" cy="40" r="40" fill="url(#gradient)" />
                        <path
                            d="M25 40L35 50L55 30"
                            stroke="white"
                            strokeWidth="5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>

                <h2 id="modal-title" className="success-modal-title">
                    Booking Confirmed!
                </h2>

                <p className="success-modal-message">
                    Your appointment has been successfully scheduled.
                    You'll receive a confirmation email shortly with all the details.
                </p>

                {bookingData && bookingData.event && (
                    <div className="success-modal-details">
                        <p><strong>Event:</strong> {appointmentType}</p>
                    </div>
                )}

                <button
                    className="success-modal-button"
                    onClick={onClose}
                >
                    Got it, thanks!
                </button>
            </div >
        </div >
    );
};

export default SuccessModal;
